import { Skeleton } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { topicRoute } from '@townsquare/routes/topic-page';

import { topicViewHeaderResource } from './resources/TopicPageHeader';
import { topicResource } from './resources/topic';
import { topicAsideResource } from './resources/topic-aside';
import { topicUpdatesAggResource } from './resources/topicUpdatesAggResource';

const TopicPageLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "topic-view" */ './ui/TopicPage'),
	loading: () => null,
});

const TopicPageAsideLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "topic-view-aside" */ './ui/TopicPageAside'),
	loading: () => null,
});

const TopicPageHeader = Loadable({
	loader: () => import(/* webpackChunkName: "topic-view-header" */ './ui/TopicHeaderRefreshed'),
	loading: Skeleton,
});

topicRoute.component = TopicPageLoadable;
topicRoute.aside = TopicPageAsideLoadable;
topicRoute.header = TopicPageHeader;
topicRoute.resources = [topicResource, topicAsideResource, topicViewHeaderResource];
topicRoute.featureGating = {
	gates: ['goal_types_m3_bundled_updates'],
	behavior: {
		type: 'override',
		override: {
			resources: [topicResource, topicUpdatesAggResource, topicAsideResource, topicViewHeaderResource],
		},
	},
};
export const topicRouterRoute = topicRoute;
